var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGuidelines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.35.925h0H1.512a.588.588 0 00-.587.587V16.86c0 .323.264.587.587.587h20.976a.588.588 0 00.587-.587V1.512a.588.588 0 00-.587-.587h-.138zm-.448 1.173v2.153H2.098V2.098h19.804zM2.098 16.274V5.424h19.804v10.85H2.098z",
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.228 14.56v.074h6.801V6.81H3.228V14.559zM4.4 7.982h4.455v5.478H4.4V7.983zM11.633 7.32h-.075v1.174h8.95V7.32h-8.875zM11.633 10.39h-.075v1.174h8.95V10.391h-8.875zM11.633 13.46h-.075v1.172h8.95V13.46h-8.875z",
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08 2.633h1.79v1.023H3.08V2.633zM8.828 2.633h1.79v1.023h-1.79V2.633zM6.014 2.633h1.79v1.023h-1.79V2.633z",
    fill: "#878787"
  })));
}
export default SvgIconGuidelines;